export const pathJoin = (parts: Array<string>, sep?: string) => {
  const separator = sep || '/';
  const replace   = new RegExp(separator+'{1,}', 'g');
  return parts.join(separator).replace(replace, separator);
}

export default pathJoin;
